// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SalesPersonInfos, { SalesPersonInfosPresentationProps } from "@store/Library/Components/SalesPersonInfos";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    currentSession: state.context.session,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

interface ContactUsSalesRepInfosStyles {
    test: SalesPersonInfosPresentationProps;
}

const contactUsSalesRepInfosStyles: ContactUsSalesRepInfosStyles = {
    test: {
        overridedStyles: {
            headerText: {
                as: "span",
                forwardAs: "h2",
                css: css`
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                    line-height: ${x => x.theme.design.typography.lineHeight.smaller};
                    margin-bottom: ${pxToRem(16)};
                `,
            },
            nameText: {
                css: css`
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                    line-height: ${x => x.theme.design.typography.lineHeight.smaller};
                    margin-bottom: ${pxToRem(16)};
                `,
            },
            infoText: {
                css: css`
                    line-height: ${x => x.theme.design.typography.lineHeight.smaller};
                    margin-bottom: ${pxToRem(16)};
                `,
            },
        },
    },
};

const styles = contactUsSalesRepInfosStyles;

const ContactUsSalesRepInfos: FC<Props> = ({ currentSession }) => {
    return <SalesPersonInfos session={currentSession} {...styles.test} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(ContactUsSalesRepInfos),
    definition: {
        displayName: "Sales Rep Infos",
        group: "Contact Us",
    },
};

export default widgetModule;
